import { useQuery } from "@tanstack/react-query";
import type { MobileAppTopBannerResponseType } from "@/features/top-banners/types/mobile-app-top-banner.types";

const useGetMobileAppTopBanner = () => {
  return useQuery({
    queryKey: ["mobile-app-top-bann"],
    queryFn: () =>
      fetch("/api/top-banners/mobile-app", {
        method: "GET",
      }).then((res) => res.json()) as Promise<MobileAppTopBannerResponseType>,
  });
};

export { useGetMobileAppTopBanner };
